import React from "react";
import "./Footer.css";
import facebook from '../../images/facebook.png';
import reddit from '../../images/reddit.png';
import linkedin from '../../images/linkedin.png';
import insta from '../../images/instagram.png';

const Footer = () => {
  return (
    <div className="footer-basic">
      <h1 className="text-center">Exoplanet Photography</h1>
      <footer>
        <div className="social">
          <a className="mx-3" href="#">
          <img  style={{width:"50px"}} src={insta} alt=""/>
          </a>
          <a href="#">
          <img style={{width:"50px"}} src={linkedin} alt=""/>
          </a>
          <a className="mx-3" href="#">
          <img style={{width:"50px"}} src={reddit} alt=""/>
          </a>
          <a className="ms-2" href="#">
            <img style={{width:"50px"}} src={facebook} alt=""/>
          </a>
        </div>
        <ul className="list-inline">
          <li className="list-inline-item">
            <a href="/home">Home</a>
          </li>
          <li className="list-inline-item">
            <a href="/about">About</a>
          </li>
          <li className="list-inline-item">
            <a href="/register">Terms</a>
          </li>
          <li className="list-inline-item">
            <a href="#">Privacy Policy</a>
          </li>
        </ul>
        <p>
         
          <small> copyright &copy; 2k22 by</small> Exoplanet Photography
        </p>
      </footer>
    </div>
  );
};

export default Footer;
